module.exports = __webpack_public_path__ + "Icono_FechaHora-Bco_512px.png";